import { inject, Injectable } from '@angular/core';
import { IUser } from '@okcargo-apps/shared-domain';
import {
  ContactFieldNames,
  ContactResponse,
  FindContactQuery,
  FindContactQueryHandler,
  OrderType,
  SearchContactsQuery,
  SearchContactsQueryHandler,
} from '@okcargo/query-processor';
import { SearchOptionsInput, transformToSearchOptions } from '../query-repository/query.mapper';
import { FindOptions } from '../query-repository/query.model';
import { BaseQueryRepository } from '../query-repository/query.repository';
import { transformToIUser, transformToIUserList } from './user.mapper';

@Injectable({
  providedIn: 'root',
})
export class UserQueryService {
  private readonly searchContactsQueryHandler: SearchContactsQueryHandler;
  private readonly findContactQueryHandler: FindContactQueryHandler;

  constructor() {
    const queryRepository = inject(BaseQueryRepository);

    // TODO move to the AsCarrier/AsShipper variants once confirmed; the app/domain layer must not
    // know which query is used.
    this.searchContactsQueryHandler = new SearchContactsQueryHandler(queryRepository);
    this.findContactQueryHandler = new FindContactQueryHandler(queryRepository);
  }

  public async searchUsers(options: SearchOptionsInput = {}): Promise<IUser[]> {
    const searchOptions: SearchOptionsInput = {
      order: [{ field: ContactFieldNames.FIRST_NAME, type: OrderType.ASC }],
      ...options,
    };

    const response: ContactResponse[] = await this.searchContactsQueryHandler.handle(
      transformToSearchOptions(searchOptions) as unknown as SearchContactsQuery,
    );

    return transformToIUserList(response);
  }

  public async findUser(options: FindOptions): Promise<IUser> {
    const response: ContactResponse = await this.findContactQueryHandler.handle({
      id: options.id,
    } as FindContactQuery);

    return transformToIUser(response);
  }
}
